import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError, ok } from "@nju/result";
import { IFetchAvailableSlotsResult } from "./types";
import { serverResponse } from "./validators";

interface IParams {
  installationToken: string;
}

export async function fetchAvailableSlots({
  installationToken,
}: IParams): Promise<IFetchAvailableSlotsResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/appointments/slots?installationToken=${installationToken}`,
    {
      validator: serverResponse,
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(result.value.dates);
}
